import { render, staticRenderFns } from "./FollowButton.vue?vue&type=template&id=dcd812da&scoped=true&"
import script from "./FollowButton.vue?vue&type=script&lang=js&"
export * from "./FollowButton.vue?vue&type=script&lang=js&"
import style0 from "./FollowButton.vue?vue&type=style&index=0&id=dcd812da&lang=scss&scoped=true&"
import style1 from "./FollowButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd812da",
  null
  
)

export default component.exports